/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Loading_ContentInputs */



/**
* | output |
* | --- |
* | "Loading content…" |
*
* @param {Artifact_Loading_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_loading_content = /** @type {((inputs?: Artifact_Loading_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Loading_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalt wird geladen…")
	return /** @type {LocalizedString} */ ("Loading content…")
});